import React from "react";
import PropTypes from "prop-types";
import { t } from "i18next";
import { Directions, translationConstants } from "../../../../../constants";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import TimezoneDisplayText from "../../../../../shared/components/TimezoneDisplayText/TimezoneDisplayText";

const TableCard = ({
  title,
  columns,
  data,
  viewAllLink,
  classNameViewAll,
  classNameTableHeader,
  rowBackground,
  isCompetitionCard,
  isShowTimezone = false,
}) => {
  return (
    <div
      className={`mx-2 my-4 p-2 shadow-box rounder-box dashboard-right-sidebar p-3 ${
        isCompetitionCard ? "competition-card-height" : ""
      }`}
    >
      <div className="d-flex justify-content-between align-items-center mb-1">
        <h6 className="top-heading">{title}</h6>
        {viewAllLink && (
          <Link
            to={viewAllLink}
            className={`text-decoration-underline ${classNameViewAll}`}
          >
            {t(translationConstants.VIEW_ALL)}
          </Link>
        )}
      </div>
      {isShowTimezone && <TimezoneDisplayText />}
      <div className="table-wrapper">
        <table className="table">
          <thead>
            <tr>
              {columns.map((column, index) => (
                <th
                  className={`fs-14 ${classNameTableHeader} dashboard-table text-nowrap ${
                    columns.length - 1 === index ? "table-column-last" : ""
                  }`}
                  key={index}
                >
                  {column.header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data?.length > 0 &&
              data?.map((item, index) => (
                <tr key={index}>
                  {columns?.map((column, colIndex) => (
                    <td
                      className={`dashboard-table table-column-text-ellipsis ${rowBackground} ${
                        columns.length - 1 === colIndex
                          ? "table-column-last"
                          : ""
                      }`}
                      key={colIndex}
                    >
                      {column.render ? column.render(item) : item[column.key]}
                    </td>
                  ))}
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      {data?.length < 1 && (
        <span
          colSpan={columns.length}
          className="d-flex justify-content-center center-text" // Add the class here
        >
          {t(translationConstants.NO_RECORD_FOUND)}
        </span>
      )}
    </div>
  );
};

TableCard.propTypes = {
  title: PropTypes.string.isRequired,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      header: PropTypes.string.isRequired,
      key: PropTypes.string.isRequired,
    })
  ).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  viewAllLink: PropTypes.string,
};

export default TableCard;
